export default {
    props: {
        target: Object,
        newTab: {
            type: Boolean,
            default: false
        },
        addBackHref: {
            type: Boolean,
            default: false
        },
        addBackHrefQuery: {
            type: Boolean,
            default: false
        },
        /** Extra query the back url should carry, e.g. the feed position of an activity item. */
        backHrefQueryParams: {
            type: Object,
            required: false
        },
        cutName: {
            type: Number,
            default: 60
        },
        postfixLabel: {
            type: String,
            required: false
        },
        tabIndex: {
            type: [Number, String],
            default: 0,
        }
    },
    computed: {
        tooltip() {
            if (this.target.deleted) {
                return 'This user has deleted their account';
            }
        },
        targetLink() {
            if (this.addBackHref) {
                return this.$backHref(this.target.link);
            } else if (this.addBackHrefQuery) {
                return this.$backHrefQuery(this.target.link, this.backHrefQueryParams);
            } else {
                return this.target.link;
            }
        }
    },
    mounted() {
        if (this.newTab) {
            this.$refs['link'].target = '_blank';
        }
    }
};